var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46.359,
    height: 47.603,
    viewBox: "0 0 46.359 47.603",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.497,
    y1: 1.004,
    x2: 0.497,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#78d7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93eaf8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.493,
    y1: 1.002,
    x2: 0.493,
    y2: 0.002,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.497,
    y1: 1,
    x2: 0.497,
    y2: 0.001,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5b537d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76709a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.51,
    y1: 0.998,
    x2: 0.51,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76719a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#928fb8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.499,
    y1: 1.008,
    x2: 0.499,
    y2: 0.002,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.506,
    y1: 0.997,
    x2: 0.506,
    y2: -0.002,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 0.022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8198",
    "data-name": "Path 8198",
    d: "M23.19,35.59l-2-3.78h0a1,1,0,0,0-1.84,0h0L17.2,35.7c-.08.14-.16.28-.23.43h0a3.58,3.58,0,1,0,6.24-.58Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8199",
    "data-name": "Path 8199",
    d: "M43.37,29.1l-2-3.79h0a1,1,0,0,0-1.85,0h0l-2.11,3.9a3.481,3.481,0,0,0-.22.43h0a3.48,3.48,0,0,0-.31,1.44,3.58,3.58,0,1,0,6.54-2Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8200",
    "data-name": "Path 8200",
    d: "M40.41,16.4h-.23a7.52,7.52,0,0,0,.18-1.59,7.28,7.28,0,0,0-7.28-7.28h0a7.26,7.26,0,0,0-1.82.24A11.59,11.59,0,0,0,8.78,10.39H8.71A8.71,8.71,0,0,0,0,19.1H0a8.71,8.71,0,0,0,8.71,8.71h31.7a5.71,5.71,0,1,0,0-11.41Z",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8201",
    "data-name": "Path 8201",
    d: "M14.43,22.2A9.56,9.56,0,0,1,24,12.63h0a9.56,9.56,0,0,1,9.4,7.812l.17,0a6.85,6.85,0,0,1,.1,13.7H14.43a6,6,0,1,1,0-11.93Z",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8202",
    "data-name": "Path 8202",
    d: "M9.39,32.93l-2-3.79h0a1,1,0,0,0-1.85,0h0L3.4,33c-.08.13-.16.28-.23.42h0a3.48,3.48,0,0,0-.31,1.44,3.58,3.58,0,1,0,7.16,0,3.54,3.54,0,0,0-.63-1.93Z",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8203",
    "data-name": "Path 8203",
    d: "M34.58,42l-2-3.79h0a1,1,0,0,0-1.85,0h0l-2.11,3.9c-.08.14-.16.28-.23.42h0A3.48,3.48,0,0,0,28,44a3.58,3.58,0,1,0,7.16,0,3.54,3.54,0,0,0-.58-2Z",
    fill: "url(#linear-gradient-6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRain);
export default __webpack_public_path__ + "static/media/Rain.9d15df0781656d403bf5c5ae7a6974b2.svg";
export { ForwardRef as ReactComponent };